import React, { Component } from "react";
import { Loading } from "../components/Loading";
import Popup from "reactjs-popup";
import { Button, Alert } from "react-bootstrap";
import ServiceCalls from "../utils/serviceCalls.js";
import TimedDisplay from "../components/TimedDisplay";
import "../styles/PopUps.css";
import RoleUtils from "../utils/roleUtils";

export class OHCIDDetailsPopUp extends Component {
	constructor(props) {
		super(props);
		this.getOHCID = this.getOHCID.bind(this);
		this.resendInvite = this.resendInvite.bind(this);
		this.createInvite = this.createInvite.bind(this);
		this.cancelInvite = this.cancelInvite.bind(this);
		this.showAlertMessage = this.showAlertMessage.bind(this);
		this.resetForm = this.resetForm.bind(this);
		this.state = {
			invite_json: {},
			is_loading: true,
			hasError: false,
			inviteMsg: "",
			inviteMsgLvl: "",
			isUpdateComplete: false,
			isPopupOpen: false,
			isCancelRequest: false,
			alertShown: false
		};
	}

	getOHCID() {
		if (this.props.userEmail) {
			ServiceCalls.getOHCIDInvite(this.props.userEmail).then(
				function (data) {
					if (data) {
						this.setState({
							invite_json: data,
							is_loading: false,
							hasError: false,
						});
						console.log(data);
					} else {
						this.setState({
							is_loading: false,
							hasError: true,
						});
					}
				}.bind(this)
			);
		}
	}

	resendInvite() {
		if (this.props.userEmail) {
			this.setState({ is_loading: true });
			ServiceCalls.resendOHCIDInvite(this.props.userEmail).then(
				function (data) {
					if (data) {
						this.setState({
							inviteMsg: "OHCID Invite request successful.  An email will be sent in 5 minutes.",
							inviteMsgLvl: "info",
							isUpdateComplete: true,
							alertShown: true,
							isLoading: false,
						});
					} else {
						this.setState({
							inviteMsg: "OHCID failed to update.",
							inviteMsgLvl: "danger",
							isUpdateComplete: true,
							alertShown: true,
							isLoading: false,
						});
					}
				}.bind(this)
			);
		}
	}

	createInvite() {
		this.setState({ is_loading: true });
		if (this.props.userEmail) {
			ServiceCalls.createOHCIDInvite(this.props.userEmail).then(
				function (data) {
					if (data) {
						this.setState({
							inviteMsg: "A new OHCID Invite successfully created.  An email will be sent in 5 minutes.",
							inviteMsgLvl: "info",
							isUpdateComplete: true,
							alertShown: true,
							isLoading: false,
						});
					} else {
						this.setState({
							inviteMsg: "OHCID failed to create.",
							inviteMsgLvl: "danger",
							isUpdateComplete: true,
							alertShown: true,
							isLoading: false,
						});
					}
				}.bind(this)
			);
		}
	}

	cancelInvite() {
		if (this.props.userEmail) {
			this.setState({ is_loading: true, isCancelRequest: true });
			ServiceCalls.cancelOHCIDInvite(this.props.userEmail, this.props.currentCompanyId).then(
				function (data) {
					if (data) {
						this.setState({
							inviteMsg: "OHCID Invite successfully canceled.",
							inviteMsgLvl: "info",
							isUpdateComplete: true,
							alertShown: true,
							is_loading: false,
						});
					} else {
						this.setState({
							inviteMsg: "OHCID failed to cancel.",
							inviteMsgLvl: "danger",
							isUpdateComplete: true,
							alertShown: true,
							is_loading: false,
						});
					}
				}.bind(this)
			);
		}
	}

	resetForm = (shouldRefresh) => {
		this.setState({
			inviteMsg: "",
			inviteMsgLvl: "",
			isUpdateComplete: false,
			isPopupOpen: false,
			isCancelRequest: false,
			alertShown: false,
		});
		if (shouldRefresh) {
			this.props.refreshTable();
		}
	};

	showAlertMessage() {
		var refreshFlag = this.state.isCancelRequest && this.state.inviteMsgLvl !== "danger";
		if (this.state.isUpdateComplete) {
			return (
				<TimedDisplay delay="3000" callback={() => this.resetForm(refreshFlag)}>
					<Alert variant={this.state.inviteMsgLvl}>{this.state.inviteMsg}</Alert>
				</TimedDisplay>
			);
		} else {
			return <></>;
		}
	}
	openPopup() {
		this.setState({
			isPopupOpen: true,
		});
		this.getOHCID();
	}

	render() {
        const { is_loading, invite_json, isPopupOpen } = this.state;
		var alreadyRegisteredUser = false;
		if(!is_loading){
			alreadyRegisteredUser = !invite_json.user && this.props.status && this.props.status.toLowerCase() === 'active';  
		} 
		var resendBtn = is_loading ? (
			<></>
		) : !alreadyRegisteredUser && new Date(invite_json.expiration_date) > new Date() && !invite_json.accepted_date ? (
			<Button className="OHCID-details-popup-buttons" style={{ float: "right", marginLeft: "10px" }} onClick={this.resendInvite}>
				Resend Invite
			</Button>
		) : (
			<></>
		);

		var recreateBtn = is_loading ? (
			<></>
		) : !alreadyRegisteredUser && new Date(invite_json.expiration_date) < new Date() && !invite_json.accepted_date && !this.props.isSPUA ? (
			<Button className="OHCID-details-popup-buttons" style={{ float: "right", marginLeft: "10px" }} onClick={this.createInvite}>
				Generate New Invite
			</Button>
		) : (
			<></>
		);

		var cancelBtn = is_loading ? (
			<></>
            // If registration is pending and the registration is an ADMIN_INVITE OR the user is site/ap admin, then show button. So if SPUA, registration needs to be pending and ADMIN_INVITE. If site/ap admin, just needs to be pending.
		) : this.props.status === "Pending" && (this.props.inviteType === "ADMIN_INVITE" || RoleUtils.canAccess(this.props.currentUser, this.props.currentCompanyId, RoleUtils.optumAdminPerms())) ? (
			<Button className="OHCID-details-popup-buttons" style={{ float: "right", marginLeft: "10px" }} onClick={this.cancelInvite}>
				Cancel Invite
			</Button>
		) : (
			<></>
		);

		return !isPopupOpen ? (
			<Button className="mpa-button-popup" style={{ float: "right", marginTop: "10px", marginLeft: "10px" }} onClick={() => this.openPopup()}>
				OneHCID Invite
			</Button>
		) : (
			<Popup open={isPopupOpen} modal closeOnDocumentClick={false} closeOnEscape={true} onClose={() => this.resetForm(false)}>
				{(close) => (
					<>
						<p id="OHCID-details-header">One HealthCare ID - Invite Details </p>
						<div className="OHCID-details-container">
							<div id="OHCID-column-info">
								{this.state.is_loading ? (
									<div>
										<Loading />
									</div>
								) : this.props.isSPUA ? (
									<div style={{ marginRight: "80px" }}>You do not have access to this information</div>
								) : this.state.hasError ? (
									<div>Error getting invite</div>
								) : alreadyRegisteredUser ? (
									<div style={{ marginRight: "80px" }}>No One HealthCare ID invite was sent to the user because they were already registered</div>
								) :this.state.invite_json ? (
                                                        <div> {/* US10561326 Display Not found if no data found */} 
										<div>
												<span className="OHCID-details-tags">First Name</span>
												<span className="OHCID-filler-tags">{this.state.invite_json.user ? (this.state.invite_json.user.first_name || "Not Found") : "Not Found"}</span>
											</div>
											<div>
												<span className="OHCID-details-tags">Last Name</span>
												<span className="OHCID-filler-tags">{this.state.invite_json.user ? (this.state.invite_json.user.last_name || "Not Found") : "Not Found"}</span>
											</div>
											<div>
												<span className="OHCID-details-tags">Email Address</span>
												<span className="OHCID-filler-tags">{this.state.invite_json.email_address || "Not Found"}</span>
											</div>
											<div>
												<span className="OHCID-details-tags">Invitation Date</span>
												<span className="OHCID-filler-tags">{this.state.invite_json.creation_date ? this.state.invite_json.creation_date : "-"}</span>
											</div>
											<div>
												<span className="OHCID-details-tags">Expiration Date</span>
												<span className="OHCID-filler-tags">{this.state.invite_json.expiration_date ? this.state.invite_json.expiration_date : "-"}</span>
											</div>
											<div>
												<span className="OHCID-details-tags">Registration Status</span>
												{/* DE1382298 Use accepted_date as source of truth; show "Registered" if user completed registration, regardless of invite expiration */}
												<span className="OHCID-filler-tags">{this.state.invite_json.accepted_date ? "Registered" : (this.state.invite_json.status ? this.state.invite_json.status : "-")}</span>
											</div>
											<div>
												<span className="OHCID-details-tags">Registration Date</span>
												<span className="OHCID-filler-tags">{this.state.invite_json.accepted_date ? this.state.invite_json.accepted_date : "-"}</span>
											</div>
											<div>
												<span className="OHCID-details-tags">UUID</span>
												<span className="OHCID-filler-tags">{this.state.invite_json.user ? (this.state.invite_json.user.uuid || "Not Found") : "Not Found"}</span>
											</div>
									</div>
								) : (
									<div>Error returned from OneHealthcare Invite Service</div>
								)}
							</div>
						</div>
						{this.state.alertShown ? this.showAlertMessage() : 
							<div>
								<Button
									style={{ float: "right", marginLeft: "10px" }}
									className="OHCID-details-popup-buttons"
									onClick={() => {
										this.resetForm(false);
									}}>
									Close
								</Button>
								{resendBtn}
								{recreateBtn}
								{cancelBtn}
							</div>
						}
					</>
				)}
			</Popup>
		);
	}
}
